import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45e9ddbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["nodvalidate"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_6 = { class: "secondary-content" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "ok-text" }
const _hoisted_9 = ["disabled"]

import { ref, computed, onMounted, onUnmounted, onBeforeUnmount } from 'vue'
import { Modal as BsModal } from 'bootstrap'
import { hideModalAsync } from './AppUtil'
import Spinner from '@webapp/util/Spinner.vue'

type OkStyles = ("outline" | "warning" | "danger")


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: {},
    titleLg: { type: Boolean },
    okText: {},
    okStyle: {},
    okDisabled: { type: Boolean },
    okClose: { type: Boolean },
    busyText: {},
    info: { type: Boolean },
    hideActions: { type: Boolean },
    small: { type: Boolean },
    large: { type: Boolean },
    validate: { type: Boolean }
  },
  emits: ["ok", "shown", "hidden", "secondaryAction"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  open,
  ok,
  reset,
  close 
})

const stateRef = ref<any>()
const busyRef = ref(false)

const modalElemRef = ref<InstanceType<typeof HTMLElement>>()

const okStyleClassRef = computed(() => 
  busyRef.value ? 'btn-secondary' : 
  props.okStyle == 'outline' ? 'btn-outline-primary' :
  props.okStyle ? `btn-${props.okStyle}` : 
  'btn-primary'
)
const okStateTextRef = computed(() => busyRef.value && props.busyText ? props.busyText : (props.okText ?? 'OK'))
const canSubmitRef = computed(() => !props.okDisabled && !busyRef.value)

onMounted(() => {
  document.addEventListener('keydown', onFormKey)
  modalElemRef.value?.addEventListener('shown.bs.modal', onShown)
  modalElemRef.value?.addEventListener('hidden.bs.modal', onHidden)
})

onBeforeUnmount(() => {
  close() // don't leave backdrop in place if reactivity unmounts an open modal
})

onUnmounted(() => {
  document.removeEventListener('keydown', onFormKey)
  modalElemRef.value?.removeEventListener('shown.bs.modal', onShown)
  modalElemRef.value?.removeEventListener('hidden.bs.modal', onHidden)
})

function onFormKey(e: KeyboardEvent) {
  if (e.key === 'Escape') {
    close()
  }
}

async function onOk(e: Event) {
  e.preventDefault() // don't submit the page as a form

  if (props.info || props.okClose) {
    await close()
    emit('ok', stateRef.value) // do NOT set busy state in this case
  }
  else {
    ok()
  } 
}

function onShown(e: Event) {
  emit('shown')
}

function onHidden(e: Event) {
  emit('hidden')
}

function ok(result?: string) {
  busyRef.value = true
  emit('ok', stateRef.value, result)
}

function open(state?: any) {
  stateRef.value = state
  busyRef.value = false

  // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
  // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
  BsModal.getOrCreateInstance(modalElemRef.value!).show()
}

function reset() {
  busyRef.value = false
}

async function close() {
  await hideModalAsync(modalElemRef.value!)
  busyRef.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalElemRef",
    ref: modalElemRef,
    class: "modal",
    tabindex: "-1",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", { 'modal-sm': props.small, 'modal-lg': props.large }])
    }, [
      _createElementVNode("form", {
        class: _normalizeClass(["modal-content", { ['needs-validation']: _ctx.validate }]),
        nodvalidate: _ctx.validate
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(props.titleLg ? 'h2' : 'h4'), { class: "modal-title" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "icon"),
              (_ctx.$slots.title)
                ? _renderSlot(_ctx.$slots, "title", { key: 0 })
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ], 64))
            ]),
            _: 3
          })),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            disabled: busyRef.value
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", { state: stateRef.value })
        ]),
        (!props.hideActions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "secondaryContent"),
                (!_ctx.$slots.secondaryContent && _ctx.$slots.secondaryText)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-inline btn-link",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('secondaryAction')))
                    }, [
                      _renderSlot(_ctx.$slots, "secondaryText")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["btn me-2", okStyleClassRef.value]),
                disabled: !canSubmitRef.value,
                onClick: onOk
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                  : _renderSlot(_ctx.$slots, "okIcon", { key: 1 }),
                _createElementVNode("span", _hoisted_8, [
                  (busyRef.value && (_ctx.$slots.busyText || props.busyText))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.$slots.busyText)
                          ? _renderSlot(_ctx.$slots, "busyText", { key: 0 })
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(props.busyText), 1)
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.$slots.okText)
                          ? _renderSlot(_ctx.$slots, "okText", { key: 0 })
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(okStateTextRef.value), 1)
                            ], 64))
                      ], 64))
                ])
              ], 10, _hoisted_7),
              (!props.info)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-primary",
                    "data-bs-dismiss": "modal",
                    disabled: busyRef.value
                  }, [
                    (_ctx.$slots.cancelText)
                      ? _renderSlot(_ctx.$slots, "cancelText", { key: 0 })
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Cancel")
                        ], 64))
                  ], 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1)
    ], 2)
  ], 512))
}
}

})